import {
  NavDropdown,
  NavLink,
  NavSection,
} from "@ecologi/react-components/src/NavigationDrawer/navigation";
import { kebabCase } from "lodash";

type NavLinkWithoutId = Omit<NavLink, "id">;
type NavDropdownWithoutId = Omit<NavDropdown, "id" | "links"> & {
  links: NavLinkWithoutId[];
};

export const addIdsToNavSection = (
  section: Array<NavLinkWithoutId | NavDropdownWithoutId>
): NavSection =>
  section.map((item) => ({
    ...item,
    id: kebabCase(item.label),
    ...("links" in item && {
      links: item.links.map((link) => ({
        ...link,
        id: kebabCase(link.label),
      })),
    }),
  }));
